import { resourcesNotIncludedInScheduleSelect } from "../constants/resourcesNotIncludedInScheduleSelect";
import { ResourceType } from "../../../../../../services/cloudchipr.api";
import { HookResourcesVisibilityReturnedDataType } from "../hooks/useResourcesVisibility.hook";
import { AutomationType } from "../types/types";
import { offHoursAvailableResourceTypes } from "../constants/common";

export const isScheduleResourceTypeVisible = ({
  resourceType,
  resourcesVisibility,
  toggledResourceTypes,
  scheduleType,
}: {
  resourceType: ResourceType;
  resourcesVisibility: HookResourcesVisibilityReturnedDataType;
  toggledResourceTypes: Map<ResourceType, boolean>;
  scheduleType: AutomationType;
}) => {
  const isVisible =
    Object.values(resourcesVisibility).every((visibility) => {
      return visibility?.[resourceType]?.show;
    }) &&
    !toggledResourceTypes.get(resourceType) &&
    !resourcesNotIncludedInScheduleSelect.has(resourceType);

  return scheduleType === "off-hours"
    ? isVisible && offHoursAvailableResourceTypes.includes(resourceType)
    : isVisible;
};
